import React from "react";

import "./Header.css";
import logo from "./assets/logo-lr.svg";

const Header = () => {
  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <a href="/" className="navbar__logo">
          <img src={logo} alt="LocalRanker" />
          <span className="navbar__tag">tools</span>
        </a>
        <a
          className="navbar__cta"
          href="https://localranker.fr/demander-demo?utm_source=localranker.tech&utm_medium=header"
          target="_blank"
          rel="noopener noreferrer"
        >
          Découvrir Localranker
        </a>
      </div>
    </nav>
  );
};

export default Header;
